import { Component, computed, inject } from "@angular/core";
import { NgIf } from "@angular/common";
import { LayoutService } from "@app/layout/service/layout.service";
import { EnvironmentService } from "@core/services/environment/environment.service";

@Component({
  selector: "[app-footer]",
  standalone: true,
  imports: [NgIf],
  template: `
    <div class="layout-footer">
      <div class="footer-logo-container">
        <img src="./icons/logo-d2d.svg" alt="logo-d2d" />
      </div>
      <span class="footer-copyright"
        >&#169; Todos los derechos reservados - 2026<span *ngIf="versionNumber"> v:{{ versionNumber }}</span></span
      >
    </div>
  `,
})
export class AppFooter {
  layoutService = inject(LayoutService);
  private readonly environmentService = inject(EnvironmentService);

  isDarkTheme = computed(() => this.layoutService.isDarkTheme());

  get versionNumber(): string | null {
    const version = this.environmentService.VERSION_NUMBER;
    return version && version.trim() !== '' ? version : null;
  }
}
